import React, { useState, useEffect } from "react";
import KitItemCard from "./Kit-Item-Card";
import { Configurations } from "../../Utils/Configurations";
import axios from "axios";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const CileKitCards = ({ plano, response, setSkuNovo, setPrecoNovo, skuNovo, precoNovo, setKitBase, toggleModalAnterior }) => {

    const [loading, setLoading] = useState(false)
    const [collapsed, setCollapsed] = useState(true)
    const [fluxoNovoItem, setFluxoNovoItem] = useState(false)
    const [novoItem, setNovoItem] = useState('')
    const [skuBusca, setSkuBusca] = useState();
    const [itens, setItens] = useState(response.itens);
    const [openModalExcluir, setOpenModalExcluir] = useState(false)
    const [itemExcluir, setItemExcluir] = useState({ skuKit: 0, idItem: 0, nome: '' });
    const [loadingBusca, setLoadingBusca] = useState(false);
    const [loadingExcluir, setLoadingExcluir] = useState(false);


    const buscaSKU = () => {
        setLoadingBusca(true)
        setSkuNovo(skuBusca);
        const config = new Configurations();
        axios.get(config.apiBasePath + `/kits-cile/produto/${skuBusca}`)
            .then(response => {
                setNovoItem(response.data.produto[0]);
                setLoadingBusca(false)
            })
            .catch(error => {
                console.log("ERROR: ", error)
                setNovoItem('Item não encontrado')
                setLoadingBusca(false)
            })
            .finally(() => {
                setLoadingBusca(false)
            });
    }


    const toggleCollapsed = () => {
        setCollapsed(!collapsed)
    }

    const toggleEdicao = () => {
        setFluxoNovoItem(!fluxoNovoItem)
    }

    const getColorKit = (tipo) => {
        switch (tipo) {
            case 88880001:
                return 'bg-info text-white';
            case 88880003:
                return 'bg-warning text-dark';
            default:
                return 'bg-purple text-white';
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "skuNovo") {
            setSkuBusca(value);
        } else if (name === "precoNovo") {
            setPrecoNovo(value);
        }
    };

    useEffect(() => {
        if (!fluxoNovoItem) {
            setSkuBusca();
            setPrecoNovo();
            setNovoItem('');
        }
    }, [fluxoNovoItem]);

    const toggleModalExcluir = () => {
        setOpenModalExcluir(!openModalExcluir)
    }

    const novoItemKit = () => {
        const valorCorrigido = precoNovo.replace(/,/g, ".");
        setLoading(true);
        const config = new Configurations();
        const body = {
            skuKit: Number(response.skuKit),
            skuItem: Number(skuNovo),
            preco: Number(valorCorrigido)
        }
        axios.post(config.apiBasePath + `/kits-cile/novo-item`, body)
            .then(response => {
                setItens(response.data.itensKit)
                setLoading(false);
                toggleEdicao()
            })
            .catch(error => {
                console.log("ERROR: ", error)
                setLoading(false);
            })
            .finally(() => {
                setLoading(false)
            });
    }

    const removeItem = () => {
        setLoading(true);
        setLoadingExcluir(true);
        const config = new Configurations();
        const body = {
            skuKit: Number(itemExcluir.skuKit),
            idItem: Number(itemExcluir.idItem),
        }
        axios.post(config.apiBasePath + `/kits-cile/remover-item`, body)
            .then(response => {
                setItens(response.data.itensKit)
                setLoading(false);
                setLoadingExcluir(false);
                toggleModalExcluir()
            })
            .catch(error => {
                console.log("ERROR: ", error)
                setLoading(false);
                setLoadingExcluir(false);
                toggleModalExcluir()
            })
            .finally(() => {
                setLoading(false)
            });
    }

    const editaPrecoItem = (kit, id, skuItem, precoItem) => {
        setLoading(true);
        const config = new Configurations();
        const body = {
            skuKit: Number(kit),
            skuItem: Number(skuItem),
            preco: Number(precoItem),
            idItem: Number(id),
        }
        axios.post(config.apiBasePath + `/kits-cile/atualizar-item`, body)
            .then(response => {
                setItens(response.data.itensKit)
                setLoading(false);
            })
            .catch(error => {
                console.log("ERROR: ", error)
                setLoading(false);
            })
            .finally(() => {
                setLoading(false)
            });
    }

    return (
        <>
            <div className="col-12 mt-4">
                <div className="card bg-white w-100">
                    <div onClick={() => toggleCollapsed()} className={`${getColorKit(response.skuKit)} text-white card-header cursor-pointer`}>
                        <div className="row no-gutters">
                            <div className="col-9 border-white">
                                <h5 className="kit-title">
                                    {response.nomeKit}
                                </h5>

                            </div>
                            <div className="col-2 text-right">
                                <h5 className="tipo-label">SKU: {response.skuKit}</h5>
                            </div>
                            <div className="col-1 text-center">
                                <i className={`cursor-pointer fa fa-chevron-${collapsed ? 'down' : 'up'} px-3 `}></i>
                            </div>

                        </div>
                    </div>
                    {collapsed ? null
                        :
                        <div className='card-body pt-3'>
                            {response.skuKit === 88880001 &&
                                <small className="mr-2">* Gerar kit anterior antes de remover os itens</small>}
                            <div className="row no-gutters mb-2">
                                <h3>Itens:</h3>
                            </div>
                            <div className="row no-gutters">
                                {loading ?
                                    <div className="d-flex justify-content-center w-100">
                                        <div className="spinner-border text-primary" role="status" />
                                    </div>
                                    :
                                    itens && itens.map((item, index) => {
                                        return (
                                            <KitItemCard
                                                editaPrecoItem={editaPrecoItem}
                                                removeItem={removeItem}
                                                skuKit={response.skuKit}
                                                item={item} key={index}
                                                toggleModalExcluir={toggleModalExcluir}
                                                setItemExcluir={setItemExcluir} />
                                        );
                                    })}
                                {fluxoNovoItem &&
                                    <div className="col-12">
                                        <div className="card-item border-bottom">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-2 d-flex justify-content-between align-items-center">
                                                    <p className="mr-2">SKU: </p>
                                                    <input name="skuNovo" type="text" className="form-control px-2" autoComplete="off" value={skuBusca} onChange={handleInputChange} />
                                                </div>
                                                <div className="col-1 text-center">
                                                    {loadingBusca ?
                                                        <div className="spinner-border spinner-border-sm text-primary" role="status" />
                                                        :
                                                        <button className='btn btn-sm btn-outline-primary ml-3' disabled={!buscaSKU} onClick={() => buscaSKU()}>
                                                            Buscar
                                                        </button>
                                                    }
                                                </div>

                                                <div className="col-6 text-center">
                                                    <p>{novoItem.nome ? novoItem.nome : novoItem}</p>
                                                </div>

                                                <div className="col-3 d-flex align-items-center">
                                                    <div className="d-flex align-items-center w-50">
                                                        <p className="mr-2">Preço: </p>
                                                        <input name="precoNovo" type="text" className="form-control px-2" autoComplete="off" value={precoNovo} onChange={handleInputChange} />
                                                    </div>
                                                    <button className='btn btn-sm btn-outline-success ml-4' onClick={() => novoItemKit(response.skuKit)} disabled={!novoItem.nome || !precoNovo || !skuNovo}>
                                                        Salvar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}

                            </div>
                            <div className="row no-gutters justify-content-between mt-4">
                                <button className='btn btn-outline-primary' onClick={() => toggleEdicao()}>
                                    {fluxoNovoItem ? 'Cancelar' : 'Adicionar item'}
                                </button>
                                {plano && response.skuKit === 88880001 &&
                                    <>
                                        {/* <button className='btn btn-outline-danger'>
                                            Remover todos os itens
                                        </button> */}
                                        <div>
                                            <button className='btn btn-outline-success' onClick={() => { toggleModalAnterior(); setKitBase(response.skuKit); }}>
                                                Copiar kit
                                            </button>
                                        </div>
                                    </>}
                            </div>
                        </div>}
                </div>
            </div>

            <Modal isOpen={openModalExcluir} toggle={toggleModalExcluir}>
                <ModalHeader toggle={toggleModalExcluir}>
                    Confirmar Exclusão
                </ModalHeader>
                <ModalBody>
                    <div className='row'>
                        <div className='col-12'>
                            <p>Tem certeza que deseja remover o item {itemExcluir.nome}?</p>
                        </div>
                    </div>

                </ModalBody>

                <ModalFooter>
                    <div className='justify-content-between d-flex w-100'>
                        <button className='btn btn-sm btn-outline-secondary' onClick={() => toggleModalExcluir()}>
                            Cancelar
                        </button>
                        {loadingExcluir ?
                            <div className="spinner-border spinner-border-sm text-danger" role="status" />
                            :
                            <button className='btn btn-sm btn-outline-danger' onClick={() => removeItem()}>
                                Excluir
                            </button>
                        }
                    </div>
                </ModalFooter>
            </Modal>
        </>
    )
}


export default CileKitCards;